import { render } from "./textarea.vue?vue&type=template&id=0d7ec5be"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/staging.infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__